import React from "react";
import {Card, CardContent, CardHeader, Container} from "@mui/material";
import { object, string, number, boolean, date, coerce } from 'zod';
import {formatDateTime, formatDateTimeParam, formatDate, formatTime} from "../../../../utils/formatDate.ts";
import * as crudgen from "../../../../share";
import {DEBOUNCE_TIME} from "../../../../utils/constants";
import { CuttingState, CuttingStatePairs, toString as toStringCuttingState } from "../../../types/models/CuttingState.d";
import { ShipmentState, ShipmentStatePairs, toString as toStringShipmentState } from "../../../types/models/ShipmentState.d";
import { ShipmentType, ShipmentTypePairs, toString as toStringShipmentType } from "../../../types/models/ShipmentType.d";
import { UserType, UserTypePairs, toString as toStringUserType } from "../../../types/models/UserType.d";
import { CordwoodMeasurementType, CordwoodMeasurementTypePairs, toString as toStringCordwoodMeasurementType } from "../../../types/models/CordwoodMeasurementType.d";





import { PrimaryCordwood } from "../../../../timber/types/models/Cordwood";

import CordwoodFormSelect from "../../../../timber/components/cordwood/CordwoodForm/CordwoodFormSelect";

import { useGetCordwoodQuery } from "../../../../timber/apis/Cordwood.api";























































import { t, msg } from "@lingui/core/macro";
import useSearchDebounce from "../../../../hooks/useSearchDebounce";
import {useLocation} from "react-router";











export const initialFormStateFn = () => { return {
    
        
        cordwoodId: null,
        
    
        
        action: "",
        
    
        
        contextHistory: "",
        
    
        
        state: null,
        
    
    }
}

export const useLocationFormState = () => {
    const initialFormState = initialFormStateFn()
    let location = useLocation();
    initialFormState.cordwoodId = PrimaryCordwood.fromQuery(location.state?.cordwoodId) || null;
    

    const { data: cordwoodIdData } = useGetCordwoodQuery(PrimaryCordwood.fromId(initialFormState.cordwoodId), { skip: !initialFormState.cordwoodId })
    

    return React.useMemo(() => initialFormState, [
        location.state,
        cordwoodIdData,
        
        
    ])
}

export const formObject = {
    
    
        cordwoodId:
        string()
                .nanoid(msg`Cordwood is required`)
                .min(1, msg`Cordwood is required`),
    
    
        action:
        string()
        .trim()
        .min(1, msg`Action is required`),
    
    
        contextHistory:
        string()
        .trim()
        .nullish(),
    
    
        state:
        string()
        .trim()
        .nullish(),
    
};

export const formSchema = object(formObject);

const CordwoodHistoryAddForm = ({watch, prefix = ''})  => {
    return (
        <Container>
           
           
   
    
    <CordwoodFormSelect
        type="none"
        name="cordwoodId"
        label={t`Cordwood`}
        prefix={prefix}
        required={ true }
    />
   
   
   
           
           
   
   <crudgen.FormInput
       required
       name={ prefix + 'action' }
       aria-label="action"
       data-testid="action"
       label={t`Action`}
       
       type='text'
       
   />
   
   
           
           
   
   <crudgen.FormInput
       
       name={ prefix + 'contextHistory' }
       aria-label="contextHistory"
       data-testid="contextHistory"
       label={t`Context History`}
       
       type='text'
       
   />
   
   
           
           
   
    <crudgen.FormSelect
        
        name={ prefix + 'state' }
        aria-label="state"
        label={t`State`}
        options={ ShipmentStatePairs }
        optionLabelMap={ toStringShipmentState }
    />
   
   
           
        </Container>
    )
}

export default CordwoodHistoryAddForm;
